import axios from 'axios';
import {
  LIST_ACCOUNTS_REQUEST,
  LIST_ACCOUNTS_SUCCESS,
  LIST_ACCOUNTS_FAIL,
  ADD_ACCOUNT_REQUEST,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAIL,
  DEPOSIT_REQUEST,
  DEPOSIT_SUCCESS,
  DEPOSIT_FAIL,
  WITHDRAW_REQUEST,
  WITHDRAW_SUCCESS,
  WITHDRAW_FAIL,
  TRANSFER_REQUEST,
  TRANSFER_SUCCESS,
  TRANSFER_FAIL,
} from '../constants/accountConstants';

export const listAccounts = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({
      type: LIST_ACCOUNTS_REQUEST,
    });

    const { userLogin } = getState();

    const { userData } = userLogin;

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userData.token}`,
      },
    };

    const { data } = await axios.get('/api/accounts', config);

    dispatch({
      type: LIST_ACCOUNTS_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    dispatch({
      type: LIST_ACCOUNTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addAccount =
  (number: string, type: string) => async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: ADD_ACCOUNT_REQUEST,
      });

      const { userLogin } = getState();

      const { userData } = userLogin;

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        },
      };

      const { data } = await axios.post(
        '/api/accounts',
        { number, type },
        config
      );

      dispatch({
        type: ADD_ACCOUNT_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      dispatch({
        type: ADD_ACCOUNT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deposit =
  (number: string, amount: number) => async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: DEPOSIT_REQUEST,
      });

      const { userLogin } = getState();

      const { userData } = userLogin;

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        },
      };

      await axios.put(`/api/accounts/deposit`, { number, amount }, config);

      dispatch({
        type: DEPOSIT_SUCCESS,
      });
    } catch (error: any) {
      dispatch({
        type: DEPOSIT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const withdraw =
  (number: string, amount: number) => async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: WITHDRAW_REQUEST,
      });

      const { userLogin } = getState();

      const { userData } = userLogin;

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        },
      };

      await axios.put(`/api/accounts/withdraw`, { number, amount }, config);

      dispatch({
        type: WITHDRAW_SUCCESS,
      });
    } catch (error: any) {
      dispatch({
        type: WITHDRAW_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const transfer =
  (num1: string, num2: string, amount: number) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: TRANSFER_REQUEST,
      });

      const { userLogin } = getState();

      const { userData } = userLogin;

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        },
      };

      await axios.put(`/api/accounts/transfer`, { num1, num2, amount }, config);

      dispatch({
        type: TRANSFER_SUCCESS,
      });
    } catch (error: any) {
      dispatch({
        type: TRANSFER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
